define('modules/salesforce/drawer/views/base.salesforce.link.view',[
    'client',
    'jquery',
    'underscore',
    'backbone',
    'modules/base/views/base.view'
], function(
    Prospector,
    $, _,Backbone,
    BaseView
){
    var BaseSalesforceLinkSubView = BaseView.extend({
        className: '',
        mainBtnLoaderRestingText: 'Export',
        mainBtnLoaderWorkingText: 'Exporting',
        initialize: function(options) {
            this.parent = options.parent;
        },
        mEvents:function(){
            return {
                'click .createLink': 'createLink',
                'click .board': 'menuPopup'
            };
        },
        onRender:function(){
        },
        createLink:function(){
            var utils = window.utils;
            if(utils.supportCookie()){
                var link = this.buildLink();
                utils.createCookie('SFDCSuccessLink', link);
            }
            Prospector.navigate('integrations/salesForce', true);
        },
        menuPopup: function(){
            if(window.location.href.indexOf("person") > -1){ // If current profile page is of a person
                if ($('.popMenu').is(":visible")) {
                    $('.popMenu').toggle('slide');
                }
            }

            if(window.location.href.indexOf("organization") > -1){// If current profile page is of a Organization
                if ($('.popMenu2').is(":visible")) {
                    $('.popMenu2').toggle('slide');
                }
            }
        },
        buildLink:function(){

        }

    });
    return BaseSalesforceLinkSubView;
});
